export const applyMask = (text: string, mask: string) => {
  if (!mask) {
    return text;
  }

  const formattedObject = mask.split('').reduce(
    (acc, character) => {
      if (acc.remainingText.length === 0) {
        return acc;
      }

      if (character !== '.') {
        return {
          formattedText: acc.formattedText + character,
          remainingText: acc.remainingText,
        };
      }

      return {
        formattedText: acc.formattedText + acc.remainingText[0],
        remainingText: acc.remainingText.slice(1),
      };
    },
    {formattedText: '', remainingText: text.split('')},
  );

  return formattedObject.formattedText + formattedObject.remainingText.join('');
};
